import React, {Component} from "react";
import {inject, observer} from "mobx-react";
import {reaction} from "mobx";
import "../assets/stylesheets/Library.scss";
import List from "./../components/List";
import loadingImg from './../assets/images/loading-white.svg';
import '../assets/stylesheets/Breadcrumb.scss';
import Device from '../utils/Device';
import Buttons from '../components/Buttons';
import Infos from '../components/Infos';
import ProductStore from '../stores/ProductStore';

@inject('Navigator', 'DropboxStore', 'SchoolStore')
@observer
export default class Library extends Component {

    static get service() {
        return ProductStore.selectedProduct === 'TEENS'
            ? '/Teacher_Desk_Conquer_Teens/Biblioteca'
            : '/Teacher_desk/Biblioteca';
    }

    componentDidMount() {

        this.props.DropboxStore.breadcrumb = [];
        this.props.DropboxStore.names = [];
        this.props.DropboxStore.items = [];
        let pathDefault = Library.service;
        this.searchFolder(pathDefault);
        this.handleBreadCrumb(pathDefault , '');

        this._productDisposer = reaction(
            () => ProductStore.selectedProduct,
            () => {
                this.props.DropboxStore.breadcrumb = [];
                this.props.DropboxStore.names = [];
                this.props.DropboxStore.items = [];
                this.searchFolder(Library.service);
                this.handleBreadCrumb(Library.service, '');
            }
        );

        document.addEventListener('registerDownloadCompleted', this.checkFileStatus);
        document.addEventListener('registerDeleteCompleted', this.checkFileStatusDeleted);
        document.addEventListener('showDownloadProgress', this.downloadProgress);
        document.addEventListener('notifiesFileExist', this.showFileExist);
        document.addEventListener('downloadBroken', this.downloadBroken);
    }

    componentWillUnmount() {
        if (this._productDisposer) this._productDisposer();
        document.removeEventListener('registerDownloadCompleted', this.checkFileStatus);
        document.removeEventListener('registerDeleteCompleted', this.checkFileStatusDeleted);
        document.removeEventListener('showDownloadProgress', this.downloadProgress);
        document.removeEventListener('notifiesFileExist', this.showFileExist);
        document.addEventListener('downloadBroken', this.downloadBroken);
    }

    // Search tree files/folders by path
    searchFolder(path){
        this.props.DropboxStore.doSearchFolder(path);
    }

    // Click list item if is folder
    handleClickList(url, name = '', clear = false) {
        this.props.DropboxStore.breadcrumb = [];
        this.searchFolder(url);
        this.handleBreadCrumb(url, name, clear);
    }

    handleDownloadFile(name, url, id, canDownload, e) {
        let _this = this;
        if (canDownload) {
            this.props.DropboxStore.doSearchTemporaryLink(url)
                .then(function () {
                    const link = _this.props.DropboxStore.link;
                    if (link) {
                        if(Device.isMobile()){
                            // call the native method
                            Device.requestDownloadFile(link, name, id, true);
                        }else{
                            // call the brownser method
                            document.getElementById('download').setAttribute('href', link);
                            document.getElementById('download').click();
                        }
                    }
                });
        } else {
            console.log("cannot download a file that already was downloaded");
        }
    }

    handleDeleteFile(name, url, id, canDelete, e) {
        if (canDelete) {
            Device.requestDeleteFile(url, name, id);
        } else {
            console.log("cannot delete a file that never was downloaded");
        }
    }

    handleOpenBook(filename, e) {
        if(Device.isMobile()){
            Device.requestOpenLibraryFile(filename);
        }else{
            let path = 'http://127.0.0.1:8887/' + filename;
            const openLink = document.getElementById('open-file');
            openLink.setAttribute('href', path);
            openLink.setAttribute('target','_blank');
            openLink.click();
        }
    }

    // Mount BreadCrumb follow dropbox path/names
    handleBreadCrumb(url, name, clear) {

        let clearUrl = url.replace(Library.service, '');
        let oldNames = [];

        if ( clear) {
            let ind = this.props.DropboxStore.ind;
            for (let l = 0; l < ind; l++) {
                oldNames[l] = this.props.DropboxStore.names[l];
            }
            this.props.DropboxStore.names = oldNames;
        }

        if (clearUrl === '') {
            return false
        }

        let caminho = clearUrl.split('/');

        this.props.DropboxStore.ind = caminho.length-2;

        // list of links
        let breadcrumb = this.props.DropboxStore.breadcrumb;

        // add name for bread-crumb
        let names = this.props.DropboxStore.names;

        if( name !== "" ) {
            names[this.props.DropboxStore.ind] = name;
        }

        // split path until the index that was clicked
        for (let i = 0; i <= this.props.DropboxStore.ind; i++) {
            let path = Library.service;
            for (let j = 0;i >= j;j++){
                path += '/' + caminho[j+1];
            }

            // add link to list
            breadcrumb.push(<span key={i} className="tree"><a className="crumb" onClick={this.handleClickList.bind(this, path, names[i], true)}>{names[i]}</a></span>);
        }
    }

    checkFileStatus = (e) => {
        const items = this.props.DropboxStore.items;
        const item = items.find(file => file.name === e.detail.filename);

        if(item !== undefined){
            item.isDownloaded = true;
            localStorage.setItem('files-'+item.id, JSON.stringify(item));
            this.setState({items: items});
        }
    };

    downloadProgress = (e) => {
        const items = this.props.DropboxStore.items;
        const item = items.find(file => file.name === e.detail.filename);

        if(item !== undefined){
            item.downloadProgress = e.detail.progress;
            localStorage.setItem('files-'+item.id, JSON.stringify(item));
            this.setState({items: items});
        }
    };

    checkFileStatusDeleted = (e) => {
        const items = this.props.DropboxStore.items;
        const item = items.find(file => file.name === e.detail.filename);
        if(item !== undefined){
            item.isDownloaded = false;
            item.downloadProgress = 0;
            localStorage.setItem('files-'+item.id, JSON.stringify(item));
            this.setState({items: items});
        }
    };

    showFileExist = (e) => {
        const items = this.props.DropboxStore.items;
        const item = items.find(file => file.name === e.detail.filename);

        if(item !== undefined){
            item.isDownloaded = true;
            item.downloadProgress = 100;
            localStorage.setItem('files-'+item.id, JSON.stringify(item));
            this.setState({items: items});
        }
    };

    // TODO test this tomorrow to check download broken
    downloadBroken = (e) => {
        const items = this.props.DropboxStore.items;
        const item = items.find(file => file.name === e.detail.filename);

        if(item !== undefined){
            item.isDownloaded = false;
            item.downloadProgress = 0;
            localStorage.setItem('files-'+item.id, JSON.stringify(item));
            this.setState({items: items});
        }
    };

    renderItems(items){
        return items.map(
            (item, index) => {

                let isInStorage = false;
                let storageItem;

                if(localStorage.getItem('files-'+item.id)){
                    storageItem = JSON.parse(localStorage.getItem('files-'+item.id));
                    isInStorage = true;
                }

                return (
                    <li key={index} className="listItem">
                        <Buttons
                            hasAllButtons={Device.isMobile()}
                            name={isInStorage ? storageItem.name : item.name}
                            url={isInStorage ? storageItem.url : item.url}
                            id={isInStorage ? storageItem.id : item.id}
                            type={isInStorage ? storageItem.type : item.type}
                            isDownloaded={isInStorage ? storageItem.isDownloaded : item.isDownloaded}
                            downloadProgress={isInStorage ? storageItem.downloadProgress : item.downloadProgress}
                            hasError={isInStorage ? storageItem.hasError : item.hasError}
                            onClickDownload={this.handleDownloadFile.bind(this)}
                            onClickDelete={this.handleDeleteFile.bind(this)}
                            onClickPlay={this.handleOpenBook.bind(this)}
                            onClickFolder={this.handleClickList.bind(this, item.url, item.name, false)}
                        />
                        <div className="title-book">
                            {item.name}
                        </div>
                        {item.type === 'file' ?
                            <Infos
                                hasAllInfos={Device.isMobile()}
                                hasError={isInStorage ? storageItem.hasError : item.hasError}
                                size={isInStorage ? storageItem.size : item.size}
                                isDownloaded={isInStorage ? storageItem.isDownloaded : item.isDownloaded}
                            /> :
                            <div></div>
                        }

                    </li>);
            });
    }

    render() {

        if ( this.props.DropboxStore.isLoading === false ) {

            let items = this.props.DropboxStore.items;

            const list = this.renderItems(items);

            let breadcrumb = this.props.DropboxStore.breadcrumb;

            return (
                <div className="Library Page">
                    <div className="container">
                        <div className="header-section">
                            <h1>Biblioteca</h1>
                            <div className="Breadcrumb">
                                <p id="bread-crumb">
                                    <span className="first">Portal do professor</span>
                                    <span className="tree">
                                        <a className="crumb"
                                           onClick={this.handleClickList.bind(this, Library.service, 'Library')}>
                                           Biblioteca
                                        </a>
                                    </span>
                                    {breadcrumb}
                                </p>
                            </div>
                        </div>
                        <div className="mt-30"/>
                        <div className="contents">
                            <List loader={this.props.DropboxStore.isLoading}
                                  counter={list.length}
                                  messageEmpty="Não há arquivos disponíveis na biblioteca.">
                                {list}
                            </List>
                            <a id="download" href="" download/>
                        </div>
                    </div>
                </div>
            )
        } else {
            return (
                <div className="Library Page">
                    <div className="container">
                        <div className="header-section">
                            <h1>Biblioteca</h1>
                            <p id="bread-crumb">
                                <span className="first">Portal do professor</span>
                                <span className="tree">
                                <a className="crumb"
                                   onClick={this.handleClickList.bind(this, Library.service)}>Biblioteca</a>
                            </span>
                            </p>
                        </div>
                        <div className="contents">
                            <List>
                                <li><img role="presentation" src={loadingImg}/></li>
                            </List>
                        </div>
                    </div>
                </div>
            )
        }
    }
}


// WEBPACK FOOTER //
// ./src/containers/Library.js